import { roundNumber } from "../modules/common/helper";
import store from "../../setup/redux/Store";
import { DECIMALS } from "../constants/common";

const formatPrice = (price: number, isRound = true, ctDecimal?: number ) => {
  if (!price) {
    return 0;
  }
  if(isRound) {
    const state = store.getState();
    const config = state.auth.user?.store?.open_store_config;
    const decimals = ctDecimal ?? DECIMALS[config?.number_format ?? 'default'] ?? 0;
    price = roundNumber(price, decimals);
  }
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
export default formatPrice;
